import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Swipeable from 'react-swipeable'
// import { TweenMax } from 'gsap'

import SplashScene from './components/splash/SplashScene'
import CurtainsScene from './components/curtains/CurtainsScene'
import VideoScene from './components/video/VideoScene'
import SlideScene from './components/slide/SlideScene'
import FeaturedSlideScene from './components/slide/FeaturedSlideScene'
import LastScene from './components/last/LastScene'
import FixedGUI from './components/fixed/FixedGUI'
import RotateNotification from '../shared/components/RotateNotification'
import { runSequence, stopSequence } from '../../utils/sequence'
import { customCSSObjectToString } from 'utils/serializerCSS'
import { getImageUrlsFromSettings, preloadImages, scrollFix } from '../../utils/templatesUtils'
import { setAnimation } from './utils'
import scenes from './scenes'
import { appLoaded } from '../shared/analytics'

import './InstantApp.scss'


export default class InstantApp extends Component {

  state = {
    scene: 1,
    prevScene: 0,
    animationProgress: 0,
    shareButtonsVisible: 0
  }

  rootWidth = 500
  // isAnimating = false

  switchScene (prevScene, newScene) {
    // if (this.isAnimating) return

    this.updateState({
      scene: newScene,
      prevScene: prevScene
    })

    // this.isAnimating = true
    // setTimeout(() => { this.isAnimating = false }, 750)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.location) {
      const prev = scenes.indexOf(this.props.location.scene)
      const next = scenes.indexOf(nextProps.location.scene)
      if (prev !== next) this.switchScene(prev, next)
    }

    if (!this.props.showcaseMode && nextProps.showcaseMode) {
      this.startAnimations()
    }
  }

  componentDidMount () {
    if (!this.props.editMode && !this.props.showcaseMode) {
      scrollFix()
    }

    // TweenMax.lagSmoothing(50, 25) // Sets smoothing lag for all js-contolled animations

    preloadImages(getImageUrlsFromSettings(this.props.settings)) // Preload all images from settings

    if (this.rootRef) {
      const rootWidth = this.rootRef.getBoundingClientRect().width
      if (rootWidth > 0) this.rootWidth = rootWidth
      // console.log('rootWidth', this.rootWidth)
    }

    if (this.prodMode()) appLoaded()
    if (this.props.editMode) {
      this.switchScene(0, 1)
      return
    }

    this.startAnimations()
  }

  startAnimations = () => {
    const { scene } = this.state
    const s1 = { fn: () => this.switchScene(0, 1), delay: 2000 }
    const s2 = { fn: () => this.switchScene(1, 2), delay: 2500 }
    const s3 = { fn: () => this.switchScene(2, 3), delay: 3500 }
    if (scene === 0) {
      this.sequenceId = runSequence([s1, s2, s3])
    } else if (scene === 1) {
      this.sequenceId = runSequence([s2, s3])
    } else if (scene === 2) {
      this.sequenceId = runSequence([s3])
    }
    // this.sequenceId = runSequence([ // Launch initial animation sequnce
    //   { fn: () => this.switchScene(0, 1), delay: 2000 },
    //   { fn: () => this.switchScene(1, 2), delay: 2500 },
    //   { fn: () => this.switchScene(2, 3), delay: 3500 },
    // ])
  }

  componentWillUnmount () {
    stopSequence(this.sequenceId)
  }

  prodMode = () => !this.props.editMode && !this.props.showcaseMode

  updateState (state) {
    if (state.scene !== this.state.scene || state.shareButtonsVisible !== this.state.shareButtonsVisible) {
      this.setState({...state, animationProgress: 0}, () => {
        if (this.props.onChange) {
          const loc = {
            scene: scenes[this.state.scene],
            shareButtonsVisible: this.state.shareButtonsVisible
          }
          if (this.prodMode()) window.ga('send', 'screenview', {screenName: JSON.stringify(loc)})
          this.props.onChange(loc)
        }
      })
    }
  }

  setShareButtonsVisible = (v) => this.updateState({ shareButtonsVisible: v })

  onNextSlide = () => {
    if ((this.state.scene > 2) && (this.state.scene < scenes.length - 1)) {
      this.switchScene(this.state.scene, this.state.scene + 1)
    }
  }

  onPrevSlide = () => {
    if (this.state.scene > 3) {
      this.switchScene(this.state.scene, this.state.scene - 1)
    }
  }

  onSwiping = (e, deltaX) => {
    // if (this.isAnimating) return

    if (this.state.scene < 3) return

    let progress = deltaX / this.rootWidth
    // Doesn't allow to progress forward on last scene and progress backward on first scene
    if ((this.state.scene === scenes.length - 1) && (progress > 0)) return
    if ((this.state.scene === 3) && (progress < 0)) return

    progress = progress > 1 ? 1 : progress
    progress = progress < -1 ? -1 : progress
    this.setState({ animationProgress: progress })
  }

  onSwiped = (e, x, y, isFlick, velocity) => {
    // if (this.isAnimating) return

    // console.log('=== onSwiped', x, this.state.scene, this.state.prevScene)
    if (x > 0) {
      this.onNextSlide()
    } else if (x < 0) {
      this.onPrevSlide()
    }
  }

  render () {
    const { settings, editMode, showcaseMode } = this.props
    const { scene, prevScene, animationProgress: progress } = this.state
    const logo = settings[`scene${scene}`].logo || settings.scene1.logo
    return (
      <div className='co_root' ref={ref => (this.rootRef = ref)}>
        {!editMode && !showcaseMode && <RotateNotification />}
        <style id='customStyles'>{customCSSObjectToString(settings.customStyles)}</style>
        <Swipeable
          onSwiped={this.onSwiped}
          onSwiping={this.onSwiping}
          trackMouse
        >
          <FixedGUI
            scene={this.state.scene}
            scenesNumber={scenes.length}
            logo={logo}
            onPrevSlide={this.onPrevSlide}
            onNextSlide={this.onNextSlide} />

          <SplashScene {...settings.scene1} visible={this.state.scene === 1} />

          <CurtainsScene {...settings.scene2} visible={this.state.scene === 2} />

          <VideoScene
            {...settings.scene3}
            onNext={this.onNextSlide}
            animation={setAnimation(3, scene, prevScene, progress)} />

          <SlideScene {...settings.scene4} slideNum={1} animation={setAnimation(4, scene, prevScene, progress)} />
          <SlideScene {...settings.scene5} slideNum={2} animation={setAnimation(5, scene, prevScene, progress)} />
          <SlideScene {...settings.scene6} slideNum={3} animation={setAnimation(6, scene, prevScene, progress)} />

          <FeaturedSlideScene {...settings.scene7} animation={setAnimation(7, scene, prevScene, progress)} />

          <LastScene {...settings.scene8} animation={setAnimation(8, scene, prevScene, progress)} setShareButtonsVisible={this.setShareButtonsVisible} />
        </Swipeable>
      </div>
    )
  }

  static defaultProps = {
    location: null,
  }

  static propTypes = {
    settings: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    editMode: PropTypes.bool,
    showcaseMode: PropTypes.bool,
    location: PropTypes.object,
  }
}



// WEBPACK FOOTER //
// ./src/templates/coffee/InstantApp.js